import { Route } from "react-router-dom";
import WhiteIps from "./WhiteIps";
import AddWhiteIps from "./AddWhiteIps";
export default (
  <Route path="WhiteListIps" exact element={<WhiteIps />}>
    <Route path="add/:id" element={<AddWhiteIps />} />
  </Route>
);
